import React from 'react';

// Replaces a section's spinner when its load fails: the message plus a Retry that re-runs that one request.
export default function LoadFailure({ message, onRetry, className = '' }) {
    return (
        <div className={`demo-load-failure text-danger small${className ? ` ${className}` : ''}`} role="alert" data-testid="demo-load-failure">
            <span>{message}</span>
            {' '}
            <button type="button" className="btn btn-link btn-sm p-0 align-baseline demo-load-failure-retry" onClick={onRetry}>
                {__('Retry')}
            </button>
        </div>
    );
}
